import { render } from "./ReviewReviewLetter.vue?vue&type=template&id=1ce252a0&ts=true"
import script from "./ReviewReviewLetter.vue?vue&type=script&lang=ts"
export * from "./ReviewReviewLetter.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\a\\1\\s\\TTI.AVE.Web\\Vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__